/*global eventDelegate:true*/
/* global MNTK:true */

export function onScroll(context) {
    const $fixedPanel = context.querySelector('[data-on-scroll]');
    if (!$fixedPanel) return;

    return;

    const className = 'visible';
    const hasClass = $fixedPanel.classList.contains(className);

    if (window.pageYOffset > 0 && !hasClass) {
        $fixedPanel.classList.add(className);
    }

    window.onscroll = function () {
        if (window.pageYOffset > 0 && !hasClass) {
            $fixedPanel.classList.add(className);
        } else if (window.pageYOffset === 0) {
            $fixedPanel.classList.remove(className);
        }
    };
}


export function OpenClientSaleModal() {
    const MODAL = 'client-sale-modal';
    const OPEN_MODAL_BUTTON = 'btn-open-client-sale-modal';
    const $modal = document.getElementById(MODAL);
    const $btn = document.getElementById(OPEN_MODAL_BUTTON);
    if (!$modal || !$btn) return;

    const $leadMagnet = document.querySelector('.lead-magnet');
    if ($leadMagnet) {
        $leadMagnet.style.bottom='65px';
    }

    eventDelegate.addEvent('click', '#btn-open-client-sale-modal', (ev, elem) => {
            openModal('client-sale-modal');

            MNTK.stat?.onReady(function () {
                MNTK.stat.trackYm('reachGoal', 'BLOG_CLICK_SKUPKA_BUTTON');
            });
        }
    );
    eventDelegate.addEvent('click', '#client-sale-modal a', (ev, elem) => {
            MNTK.stat?.onReady(function () {
                MNTK.stat.trackYm('reachGoal', 'BLOG_CLICK_SKUPKA_CONTACTS');
            });
        }
    );
}
